<template>
  <v-alert
      class="my-3"
      text
      border="left"
      :type="error ? 'error' : 'info'"
      :icon="icon || 'mdi-information-outline'"
  >
    <div>
      {{error ? error.message : message}}
    </div>
    <v-divider
        v-if="error && error.additionalInfo || subMessage"
        class="mt-2 mb-4"
        :class="error ? 'error' : 'info'"
        style="opacity: 0.22"
    ></v-divider>
    <div
        v-if="subMessage"
        class="sub-message"
    >
      {{subMessage}}
    </div>
    <div
        v-if="error && error.additionalInfo"
        class="sub-message"
    >
      {{error.additionalInfo}}
    </div>
    <v-row
        v-if="error"
        class="mt-2"
    >
      <v-col>
        <v-btn
          color="primary"
          outlined
          @click="openBuyouts"
        >
          <v-icon left>
            mdi-cart
          </v-icon>
          Перейти к закупкам
        </v-btn>
      </v-col>
    </v-row>
<!--    <v-row-->
<!--        v-if="error && !error.hideSupportLink"-->
<!--        class="mt-2"-->
<!--    >-->
<!--      <v-col>-->
<!--        <v-btn-->
<!--          color="error"-->
<!--          outlined-->
<!--          target="_blank"-->
<!--          :href="supportUrl"-->
<!--        >-->
<!--          <v-icon-->
<!--              left-->
<!--          >-->
<!--            mdi-email-outline-->
<!--          </v-icon>-->
<!--          Написать в техподдержку-->
<!--        </v-btn>-->
<!--      </v-col>-->
<!--    </v-row>-->
  </v-alert>
</template>

<script>
import {getSourceId} from '@/composables/context'
import {appStates} from '@/constants'

export default {
  name: 'Info',
  data () {
    return {
      supportUrl: this.$API.SUPPORT_URL
    }
  },
  methods: {
    openBuyouts () {
      const sourceId = getSourceId()
      if (sourceId) {
        this.$router.replace(appStates.sourceItemContent.path.replace(':sourceId', sourceId))
      } else {
        this.$router.replace(appStates.sourceList.path)
      }
    }
  },
  props: {
    error: {
      type: Object
    },
    icon: {
      type: String
    },
    message: {
      type: String
    },
    subMessage: {
      type: String
    }
  }
}
</script>

<style scoped>
.sub-message {
  font-size: 13px;
}
</style>
